export default __webpack_public_path__ + "c83da22.png";